export default {
  no_mobile_app: 'Keine Mobile App konfiguriert',
  mobile_app_not_live: 'Mobile App nicht live',
};
